export const RUG_SWATCH_TYPE = "rug";

/**
 * Whether a swatch product is a paid rug sample rather than a free fabric
 * swatch. A product never carries both kinds, so the first swatch it offers
 * settles the copy for every surface on the PDP.
 *
 * @param {?Object} swatch - anything carrying a `swatchType` string
 */
export const isRugSwatch = (swatch) => swatch?.swatchType === RUG_SWATCH_TYPE;

/**
 * @param {?{amount: string, currencyCode: string}} money - Storefront MoneyV2
 * @returns {?string} formatted price, or null when the swatch carries none
 */
export const formatSwatchPrice = (money) =>
  money
    ? window.formatMoney(parseFloat(money.amount), false, money.currencyCode)
    : null;
